// extracted by mini-css-extract-plugin
export var item = "MobileNavItem-module--item--7f1f5";